import { FeatureFlags, useFeatureFlag } from '~/utils/featureflagsV2';
import { isNull } from 'lodash';
import { getOnboarding2024FlagStorage, setOnboarding2024FlagStorage } from '../utils/onboarding';

export const useOnboarding2024 = () => {
  const storedFlagValue = getOnboarding2024FlagStorage();
  const joinFlow = useFeatureFlag(FeatureFlags.JOIN_FLOW);
  if (isNull(storedFlagValue) && !isNull(joinFlow)) {
    const newJoinFlow = joinFlow?.variation === 'variant';
    setOnboarding2024FlagStorage(newJoinFlow);
    return { newJoinFlow };
  }
  return { newJoinFlow: storedFlagValue === 'true' };
};
